import mappingTypes from "./mapping-types.js";
const objectTypes = {
  Concept: {
    type: ["http://www.w3.org/2004/02/skos/core#Concept"]
  },
  ConceptScheme: {
    type: ["http://www.w3.org/2004/02/skos/core#ConceptScheme"]
  },
  ConceptMapping: {
    type: mappingTypes.map((type) => type.uri)
  },
  ConceptOccurrence: {},
  Registry: {
    type: [
      "http://www.w3.org/ns/dcat#Catalog",
      "http://purl.org/cld/cdtype/CatalogueOrIndex"
    ]
  },
  Distribution: {
    type: [
      "http://www.w3.org/ns/dcat#Distribution"
    ]
  },
  Service: {
    type: [
      "http://www.w3.org/ns/dcat#DataService"
    ]
  },
  Dataset: {
    type: [
      "http://www.w3.org/ns/dcat#Dataset"
    ]
  },
  Concordance: {
    type: [
      "http://rdf-vocabulary.ddialliance.org/xkos#Correspondence",
      "http://rdfs.org/ns/void#Linkset",
      "http://purl.org/spar/fabio/VocabularyMapping"
    ]
  },
  Resource: {},
  Item: {},
  ConceptBundle: {},
  Annotation: {
    type: [
      "Annotation",
      "http://www.w3.org/ns/oa#Annotation"
    ]
  }
};
const objectTypeUris = Object.keys(objectTypes).reduce((map, name) => {
  for (let uri of objectTypes[name].type || []) {
    map[uri] = name;
  }
  return map;
}, {});
function guessObjectType(obj, shortname = false) {
  let type;
  if (typeof obj === "string" && obj) {
    if (obj in objectTypeUris) {
      type = objectTypeUris[obj];
    } else {
      obj = obj.toLowerCase().replace(/s$/, "");
      type = Object.keys(objectTypes).find((name) => {
        const lowercase = name.toLowerCase();
        if (lowercase === obj || lowercase === "concept" + obj) {
          return true;
        }
      });
    }
  } else if (typeof obj === "object") {
    if (obj.type) {
      let types = Array.isArray(obj.type) ? obj.type : [obj.type];
      for (let uri of types) {
        if (uri in objectTypeUris) {
          type = objectTypeUris[uri];
          break;
        }
      }
    }
  }
  return shortname && type ? type.toLowerCase().replace(/^concept(.+)/, "$1") : type;
}
function usedObjectTypes(obj) {
  const types = [];
  const uris = {
    concepts: "http://www.w3.org/2004/02/skos/core#Concept",
    schemes: "http://www.w3.org/2004/02/skos/core#ConceptScheme",
    mappings: "http://www.w3.org/2004/02/skos/core#mappingRelation",
    concordances: "http://rdf-vocabulary.ddialliance.org/xkos#Correspondence",
    // occurrences: "", # TODO
    registries: "http://www.w3.org/ns/dcat#Catalog",
    types: "http://www.w3.org/2002/07/owl#Class",
    properties: "http://www.w3.org/1999/02/22-rdf-syntax-ns#Property",
    annotations: "http://www.w3.org/ns/oa#Annotation"
  };
  for (let field in uris) {
    if (obj[field]?.find((x) => x !== null)) {
      types.push(uris[field]);
    }
  }
  return types.sort();
}
export {
  guessObjectType,
  objectTypes,
  usedObjectTypes
};
